import {
	ModalContainer,
	Spinner,
	StepperNavigation,
} from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { ReactComponent as CampaignIcon } from 'App/assets/img/campaigns_variant.svg';
import React from 'react';
import { NewCampaignForm } from './components/NewCampaignForm';
import { useNewCampaign } from './NewCampaign.hooks';
import welbeSuccess from 'App/assets/img/welbe-hearth.png';

import {
	Container,
	Header,
	Description,
	Footer,
	Title,
	Wrapper,
	Main,
	LoadingContainer,
	FinishModal,
} from './NewCampaign.styles';
import { ModalPreviewEmailCommunication } from '../ModalPreviewEmailCommunication/ModalPreviewEmailCommunication';

export const NewCampaign = (): JSX.Element => {
	const {
		active,
		campaign,
		datesScheduled,
		isLoading,
		isFormLoading,
		type,
		isLoadingUpload,
		stepperOptions,
		completed,
		formTitle,
		isFinishModalOpen,
		navigate,
		hasError,
		campaignId,
		showModalPreviewEmailCommunication,
		handleStepper,
		handleClick,
		handleChange,
		handlePreviewEmailCommunication,
		handleClosePreviewEmailCommunication,
	} = useNewCampaign();

	return (
		<Container>
			<Wrapper>
				<CampaignIcon className="logo" width="60px" height="60px" />
				<Header>
					<Title>{formTitle}</Title>
					<StepperNavigation
						itemLabel="name"
						items={stepperOptions}
						onClick={handleStepper}
						active={active}
						complete={completed}
					/>
				</Header>
				<Main>
					<Title>{stepperOptions[active].title}</Title>
					<Description>{stepperOptions[active].description}</Description>
					{isFormLoading ? (
						<LoadingContainer>
							<Spinner size="40px" />
						</LoadingContainer>
					) : (
						<NewCampaignForm
							activeType={type}
							error={hasError}
							campaign={campaign}
							key={stepperOptions[active].id}
							datesScheduled={datesScheduled.reverse()}
							loading={isLoading}
							loadingUpload={isLoadingUpload}
							content={campaign[type]}
							onChangeValue={handleChange}
						/>
					)}
				</Main>
			</Wrapper>
			<Footer>
				<div>
					<Button width="170px" onClick={handlePreviewEmailCommunication}>
						Previsualizar
					</Button>
				</div>
				<div>
					<Button
						width="130px"
						variant="outline"
						disabled={active === 0 || isLoading || isLoadingUpload}
						onClick={() => handleClick('previous')}
					>
						Regresar
					</Button>
					<Button
						disabled={isLoading || isLoadingUpload}
						width="130px"
						onClick={() => handleClick('next')}
						loading={isLoading}
					>
						Continuar
					</Button>
				</div>
			</Footer>
			<ModalContainer
				visible={isFinishModalOpen}
				width="400px"
				height="200px"
				padding="24px"
			>
				<FinishModal>
					<img src={welbeSuccess} />
					<p>
						¡Tu campaña <span className="boldtext">{formTitle}</span> fue creada
						con éxito!
					</p>
					<Button
						width="100px"
						onClick={() => navigate(`/campaign/${campaignId}`)}
					>
						Continuar
					</Button>
				</FinishModal>
			</ModalContainer>
			{showModalPreviewEmailCommunication && (
				<ModalPreviewEmailCommunication
					campaign={{
						id: campaignId,
						communication: {
							message: campaign[type].messageBody,
							type: campaign[type].communicationTypeId,
							useCustomTemplate: campaign[type].useCustomTemplate,
						},
					}}
					onClose={handleClosePreviewEmailCommunication}
				></ModalPreviewEmailCommunication>
			)}
		</Container>
	);
};
